import * as bootstrap from "bootstrap";
import { Link } from "react-router-dom";

import "./bottombar.css";

function Bottombar(props) {

    /*
    window.bootstrap = bootstrap;
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    [...popoverTriggerList].map((popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl));
    */

    return (
        <div>
            <div className="bottombar px-4 border-bottom">
                <div className="row h-100">
                    <div className="col-md d-flex">
                        <div className={props.page === "dashboard" ? "bottombar-div-selected mx-3 pb-1 align-self-end" : "bottombar-div mx-3 pb-1 align-self-end"}>
                            <Link className={props.page === "dashboard" ? "bottombar-link-selected" : "bottombar-link"} to="/homepage/dashboard" onClick={() => props.setPage("dashboard")}>
                                Dashboard
                            </Link>
                        </div>
                        <div className={props.page === "orderslist" ? "bottombar-div-selected mx-3 pb-1 align-self-end" : "bottombar-div mx-3 pb-1 align-self-end"}>
                            <Link className={props.page === "orderslist" ? "bottombar-link-selected" : "bottombar-link"} to="/homepage/orderslist" onClick={() => props.setPage("orderslist")}>
                                Lista ordini
                            </Link>
                        </div>
                        <div className={props.page.includes("recipeslist") ? "bottombar-div-selected mx-3 pb-1 align-self-end" : "bottombar-div mx-3 pb-1 align-self-end"}>
                            <Link className={props.page.includes("recipeslist") ? "bottombar-link-selected" : "bottombar-link"} to="/homepage/recipeslist" onClick={() => props.setPage("recipeslist")}>
                                Lista ricette
                            </Link>
                        </div>
                    </div>
                    <div className="bottom-icons col-sm align-self-center">
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn p-0" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-title="Nome Cognome" data-bs-content="#12345678">
                                <span className="bottombar-icon border p-1 material-symbols-outlined text-secondary">account_circle</span>
                            </button>

                            <div style={{ width: "15px" }}></div>
                            <button type="button" className="btn p-0" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Nessuna notifica">
                                <span className="bottombar-icon border p-1 material-symbols-outlined text-secondary">notifications</span>
                            </button>
                            <div style={{ width: "15px" }}></div>
                            <button className="btn p-0">
                                <span className="bottombar-icon border p-1 material-symbols-outlined text-secondary">settings</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottombar-sm px-2 border-bottom">
                <div className="row h-100">
                    <div className="col align-self-end text-center">
                        <Link className={props.page === "dashboard" ? "bottombar-sm-link-selected" : "bottombar-sm-link"} onClick={() => props.setPage("dashboard")} to="/homepage/dashboard">
                            <p className={props.page === "dashboard" ? "selected-text-page" : "text-page"}>Dashboard {props.index}</p>
                        </Link>
                    </div>
                    <div className="col align-self-end text-center">
                        <Link className={props.page === "orderslist" ? "bottombar-sm-link-selected" : "bottombar-sm-link"} onClick={() => props.setPage("orderslist")} to="/homepage/orderslist">
                            <p className={props.page === "orderslist" ? "selected-text-page" : "text-page"}>Lista ordini</p>
                        </Link>
                    </div>
                    <div className="col align-self-end text-center">
                        <Link className={props.page === "recipeslist" ? "bottombar-sm-link-selected" : "bottombar-sm-link"} onClick={() => props.setPage("recipeslist")} to="/homepage/recipeslist">
                            <p className={props.page === "recipeslist" ? "selected-text-page" : "text-page"}>Lista ricette</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Bottombar;
